var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-card",
    { staticClass: "gwnl-card basic-box-card", attrs: { shadow: "never" } },
    [
      _c(
        "div",
        {
          staticClass:
            "clearfix standard-size-16 font-medium align-items-center",
          attrs: { slot: "header" },
          slot: "header",
        },
        [
          _c("yxt-svg", {
            staticClass: "mr12",
            attrs: {
              "remote-url": _vm.gwnlMediaDomain + "svg/",
              width: "28px",
              height: "28px",
              "icon-class": "gwnl_pc_jq_detail_basic_info",
            },
          }),
          _c("span", [
            _vm._v(_vm._s(_vm.$t("pc_gwnl_model_template__info_basic_title"))),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex justify-content-between flex-wrap is-preview" },
        [
          _c("div", { staticClass: "flex row-item pb16" }, [
            _c("div", { staticClass: "color-gray-7 mr24" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("gwnl_gwnl_pc_model_level")) +
                  "：\n      "
              ),
            ]),
            _c("div", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.previewBasic.enableSkillLevel
                      ? _vm.$t("pc_gwnl_level_model")
                      : "" +
                          _vm.$t("pc_gwnl_global_tag_noLevel") +
                          _vm.$t("pc_gwnl_eval_model")
                  ) +
                  "\n      "
              ),
            ]),
          ]),
          _c("div", { staticClass: "flex row-item pb16" }, [
            _c("div", { staticClass: "color-gray-7 mr24" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("gwnl_gwnl_pc_model_attribute")) +
                  "：\n      "
              ),
            ]),
            _c("div", [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.previewBasic.attribute || "--") +
                  "\n      "
              ),
            ]),
          ]),
          _c("div", { staticClass: "flex row-item pb16" }, [
            _c("div", { staticClass: "color-gray-7 mr24" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("gwnl_gwnl_pc_model_hierarchical")) +
                  "：\n      "
              ),
            ]),
            _c("div", [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.previewBasic.hierarchical || "--") +
                  "\n      "
              ),
            ]),
          ]),
        ]
      ),
      _c("div", { staticClass: "gwnl-jq-preview__basic" }, [
        _c("div", { staticClass: "gwnl-jq-preview__basic-row" }, [
          _c("div", { staticClass: "gwnl-jq-preview__basic-row-box" }, [
            _c("div", { staticClass: "color-gray-7 mr24" }, [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.$t("pc_gwnl_model_template__table_column_description")
                  ) +
                  "：\n        "
              ),
            ]),
            _vm.previewBasic.modelDesc
              ? _c("div", {
                  staticClass:
                    "gwnl-jq-preview__basic-row-box-info gwnl-pre-wrap",
                  domProps: { textContent: _vm._s(_vm.previewBasic.modelDesc) },
                })
              : _c("div", { staticClass: "color-gray-6" }, [
                  _vm._v("\n          --\n        "),
                ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }